/*
  Summarizes all the allocation guides to date
*/
import { Fragment, useEffect } from 'react'

import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { fetchAllocationGuidesSummary } from '@/src/actions/allocationGuideActions'
import { formatCurrencyFromCents } from '@/utils/currencyHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import { AllocationGuideSummary as Summary } from '@/src/reducers/finances/allocationGuidesReducer'
import { Alert, Card, CardColors, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'

export const AllocationGuideSummary = ({
  summaries,
}: {
  summaries?: Summary[]
}) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!summaries) {
      fetchAllocationGuidesSummary()(dispatch)
    }
  }, [dispatch, summaries])

  let allocationGuideSummaries = useReselector(
    (state) => state.allocationGuides.summaries
  )

  if (summaries) {
    allocationGuideSummaries = summaries
  }

  const content = () => {
    if (allocationGuideSummaries.length === 0) {
      return (
        <Alert
          variant="warning"
          description="No allocation guides have been processed yet! The next guide will be
          sent to you on the 15th."
        />
      )
    }

    return allocationGuideSummaries.map(
      ({ allocationRuleName, totalAmount }, idx) => (
        <Fragment key={`AllocationGuideSummary_${allocationRuleName}_${idx}`}>
          <br />
          <Text variant={TypographyStyles.BODY_SM} className="mb-2">
            <b>{allocationRuleName}</b>
          </Text>
          <Text variant={TypographyStyles.BODY_SM}>
            <CurrencyFormatLabel value={formatCurrencyFromCents(totalAmount)} />
          </Text>
        </Fragment>
      )
    )
  }

  return (
    <Card color={CardColors.LEVEL_0}>
      <Text variant={TypographyStyles.H2} className="mb-2">
        Year to Date Statistics*
      </Text>
      <Text variant={TypographyStyles.BODY_SM} className="mb-4">
        <i>*Since enabling Heard Allocation Guide </i>
      </Text>
      {content()}
    </Card>
  )
}
